<script setup>
import LandingNav from '@/components/landing/LandingNav.vue'
import { useRoute } from 'vue-router';
const route = useRoute();
</script>

<template>
    <div class="min-h-screen flex flex-col main-gradient">
        <main class="flex-1 flex flex-col">
            <div v-if="route.path !== '/login' && route.path !== '/' && route.path !== '/register' && route.path !== '/account-creation'" class="w-full top-0 sticky z-[9999]">
                <LandingNav />
            </div>
            <div class="flex-1 h-[calc(100vh-64px)] ">
                <router-view />
            </div>
        </main>
    </div>
</template>
<style scoped>
.main-gradient {
    background: radial-gradient(ellipse at center top, #141414 0%, #070707 50%, #000000 100%);
    background-size: 100% 100vh;
    background-repeat: no-repeat;
    background-attachment: fixed;
}
</style>